/* eslint-disable no-console */
import {FC, useMemo} from "react";
import {CreatePlanSummary} from "../../view-model";
import {summarizePlan} from "../../helpers";
import {usePlan} from "../../context";
import {SummaryCard} from "../common";
import {OrganizationDetailsColumn} from "./OrganizationDetailsColumn";
import "../common/BuilderStep.scss";

export const ReviewPlanStep: FC = () => {
  const {plan} = usePlan();
  const summary = useMemo<CreatePlanSummary>(() => summarizePlan(plan), [plan]);

  return (
    <section
      id={"review-plan-step"}
      data-testid={"review-plan-step"}
      className={"organization-builder-step review-plan-step"}>
      <section
        id={"summary-section"}
        data-testid={"summary-section"}
        className={"summary-section"}>
        <SummaryCard
          baseLabelKey={"create-organization.plan-summary"}
          qualifier={"creating"}
          count={1}
        />
      </section>
      <section
        id={"tenant-section"}
        data-testid={"tenant-section"}
        className={"tenant-section"}>
        {/* TenantDetails Here */}
      </section>
      <section
        id={"organization-section"}
        data-testid={"organization-section"}
        className={"organization-section"}>
        <OrganizationDetailsColumn plan={plan} />
      </section>
    </section>
  );
};
